var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-error"},[_c('h5',[_vm._v("ERROR 404")]),_c('h3',[_vm._v("Error de red local")]),_c('button',{on:{"click":_vm.goHome}},[_vm._v("Volver a cargar")])])}
var staticRenderFns = []

export { render, staticRenderFns }